import useAssets from "hooks/useAssets";
import { generateRandomInteger } from "utils/numberUtils";
import { Navigate } from "react-router-dom";
import useV2s from "hooks/useV2s";
import { useMemo } from "react";

type V2RedirectProps = {
  basePath: string;
};

const V2Redirect = ({ basePath }: V2RedirectProps) => {
  const { v2sInWallet } = useAssets();
  const { allV2Ids } = useV2s();

  const defaultTokenId = useMemo(() => {
    if (!allV2Ids.length) {
      return null;
    }

    const lastTokenId = localStorage.getItem("lastTokenId");
    const lastTokenIdAsNumber = lastTokenId
      ? parseInt(lastTokenId, 10)
      : v2sInWallet?.[0];

    if (lastTokenIdAsNumber !== undefined) {
      if (allV2Ids.includes(lastTokenIdAsNumber)) {
        return lastTokenIdAsNumber;
      } else {
        localStorage.removeItem("lastTokenId");
      }
    }

    return allV2Ids[generateRandomInteger(0, allV2Ids.length)];
  }, [v2sInWallet, allV2Ids]);

  return <Navigate to={`${basePath}/${defaultTokenId}`} replace />;
};

V2Redirect.storeLastTokenId = (tokenId?: number) => {
  if (tokenId) {
    localStorage.setItem("lastTokenId", tokenId.toString());
  }
};

export default V2Redirect;
